import { FC } from 'react';
import cx from 'classnames';

import { CheckedIcon, CloseNewIcon } from 'components/Icon';

import styles from './Feature.module.scss';

export type PricingPlanFeatureProps = {
  available?: boolean;
};

const PlanFeature: FC<PricingPlanFeatureProps> = ({ children, available = false }): JSX.Element => (
  <div className={cx(styles.container, { [styles.unavailable]: !available })}>
    {available ? <CheckedIcon height={20} width={20} /> : <CloseNewIcon height={20} width={20} />}
    <span>{children}</span>
  </div>
);

export default PlanFeature;
